import { useCurrencyStore } from 'core/hooks';
import { Amount, CurrencyHelper } from 'utils/currency.util';

const useToCurrency = () => {
  const currencyStore = useCurrencyStore();

  //const nominalAmountFormatted = currencyStore.getCurrencyValue(nominalAmount);
  //Note: This is doing currency conversion to need to use CurrencyHelper directly.
  //Also the nominal amount is always in USD for recurring payments, even if the user
  //has selected a different currency.

  return (value: number) => {
    const amount: Amount = {
      value: value,
      currencySymbol: currencyStore.mainCurrency?.symbol,
    };

    return CurrencyHelper.FormatAmountToCurrency(amount);
  };
}

export default useToCurrency;